import type { DynamicDialogConfig } from 'primeng/dynamicdialog';

export const DIALOG_CONFIG_FOR_FILTERS: DynamicDialogConfig = {
  position: 'center',
  modal: true,
  width: '75%',
  closable: true,
  closeOnEscape: true,
  maximizable: true,
  autoZIndex: true,
  baseZIndex: 1000,
  breakpoints: {
    '640px': '100%',
    '768px': '90%',
    '1024px': '85%',
    '1280px': '80%',
  },
};
